import { Button, DialogContent, Divider, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { Stack } from "@mui/system";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";

const RulesModal = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{ padding: "16px none" }}
    >
      <Stack display="flex" direction="row" justifyContent="space-between">
        <DialogTitle id="alert-dialog-title">
          {t("rulesDialog.rulesTitle")}
        </DialogTitle>
        <Button type="icon" size="medium" onClick={onClose}>
          <CloseIcon />
        </Button>
      </Stack>
      <DialogContent>
        <Typography
          fontWeight={700}
          variant="subtitle-1"
          component="div"
          marginBottom="8px"
        >
          Organizator
        </Typography>
        <Typography variant="body1" component="div">
          Program lojalnosti potrošača (u daljem tekstu: Program), pod nazivom
          “Izaberi poklone uz najbolje Coca-Cola osveženje”, organizuje
          kompanija Coca-Cola HBC-Srbija d.o.o. Zemun (u daljem tekstu:
          Organizator).
        </Typography>
        <Typography variant="body1" component="div">
          Program se sprovodi u svrhu promocije proizvoda koje Organizator
          proizvodi.
        </Typography>
        <Typography
          fontWeight={700}
          variant="subtitle-1"
          component="div"
          marginBottom="8px"
          marginTop="24px"
        >
          Trajanje, svrha i mesto odvijanja programa
        </Typography>
        <Typography variant="body1" component="div">
          Program traje od 10.04.2023. godine do isteka zaliha nagrada, a
          najkasnije do 23.05.2023. godine, uključujući oba datuma i odvija se
          na području Republike Srbije, bez Kosova i Metohije
        </Typography>
        <Typography
          fontWeight={700}
          variant="subtitle-1"
          component="div"
          marginBottom="8px"
          marginTop="24px"
        >
          Informacije o Promociji
        </Typography>
        <Typography variant="body1" component="div">
          Ova Pravila Programa i ostale detaljnije informacije u vezi sa
          njegovim sprovođenjem su objavljene na web stranici Coke loyalty
          Aplikaciji.
        </Typography>
        <Typography
          fontWeight={700}
          variant="subtitle-1"
          component="div"
          marginBottom="8px"
          marginTop="24px"
        >
          Pravila Promocija i opšti uslovi učestvovanja
        </Typography>
        <Typography variant="body1" component="div">
          U programu učestvuju sledeći Coca-Cola proizvodi (u daljem tekstu:
          Promotivna pakovanja):
        </Typography>
        <ul>
          <li>
            Coca-Cola Original od 0.25l upakovana u povratnu staklenu bocu, i
            Coca-Cola Zero od 0.25l, upakovana u povratnu staklenu bocu;
          </li>
          <li>Fanta orange od 0.25l upakovana u povratnu staklenu bocu</li>
          <li>Sprite lemon od 0.25l upakovana u povratnu staklenu bocu</li>
          <li>
            Schweppes Bitter Lemon, Tonic Water, Pink Tonic i Tangerina od 0.25l
            upakovana u povratnu staklenu bocu
          </li>
          <li>Rosa gazirana upakovana od 0.33l u nepovratnu staklenu bocu</li>
          <li>
            Romerquelle od 0.33l upakovana u povratnu staklenu bocu i
            Romerquelle limunska trava od 0.33 upakovana u povratnu staklenu
            bocu
          </li>
          <li>Ultra energy od 0.25 upakovana u nepovratnu ambalazu</li>
        </ul>
        <Typography variant="body1" component="div">
          U zavisnosti od vrste proizvoda, promotivna pakovanja nose određeni
          broj bodova i to:
        </Typography>
        <ul>
          <li>
            Coca-Cola Original 0.25l upakovana u povratnu staklenu bocu – 1 bod
          </li>
          <li>
            Coca-Cola Zero 0.25l upakovana u povratnu staklenu bocu – 2 boda
          </li>
          <li>
            Fanta orange od 0.25l upakovana u povratnu staklenu bocu – 1 bod
          </li>
          <li>
            Sprite lemon od 0.25l upakovana u povratnu staklenu bocu – 1 bod
          </li>
          <li>
            Scheweppes Bitter Lemon, Tonic Water, Pink Tonic i Tangerina od
            0.25l upakovana u povratnu staklenu bocu – 2 boda
          </li>
          <li>
            Rosa gazirana od 0.33l upakovana u nepovratnu staklenu bocu – 2 boda
          </li>
          <li>
            Romerquelle od 0.33l upakovana povratnu staklenu bocu – 2 boda
          </li>
          <li>
            Romerquelle od 0.33l upakovana povratnu staklenu bocu – 2 boda
          </li>
          <li>Ultra energy od 0.25 upakovana u nepovratnu ambalazu – 2 boda</li>
        </ul>
        <Typography variant="body1" component="div">
          Kako bi stekli pravo na učešće u promociji, neophodno je da učesnici
          isprate korake navedene ispod:
        </Typography>
        <ol>
          <li>
            Nakon što učesnik kupi Promotivna pakovanja potrebno je da preuzme
            Coke loyalty web Aplikaciju (u daljem tekstu: Aplikacija) slikanjem
            QR coda na stolu lokala za Android uređaje ili Apple za iPhone
            mobilne uređaje, registruje svoj profil unoseći svoju i-mejl adresu
            ,ime i prezime pod kojim će se voditi njegov profil u okviru
            Aplikacije. Nakon uspešno obavljene registracije učesnik može da
            učestvuje u Promociji. Ukoliko učesnik ima već registrovani profil
            na Aplikaciji može koristiti svoj postojeći profil.
          </li>
          <li>
            Kada je učesnik registrovan, potrebno je da skenira fiskalni račun
            iz lokala definisan ovim Pravilima. Unet račun će se konvertovati u
            bodove. Jedan slikani fiskalni račun donosi adekvatan broj bodova u
            zavisnosti od vrste Promotivnog pakovanja, u skladu sa bodovanjem
            navedenim u ovim Pravilima.
          </li>
          <li>
            Kada učesnik sakupi minimalan potreban broj bodova, potrebno je da
            izabere određenu nagradu koje su opisane u daljem tekstu ovih
            Pravila.
          </li>
          <li>
            Sa jednog registrovanog profila učesnik može uneti neograničeni broj
            fiskalnih računa. Svi generisani bodovi u Aplikaciji tokom ove
            Promocije važice samo tokom ove Promocije. Nakom završetka ove
            Promocije bodovi na profilu učesnika biće obrisani i neće postojati
            mogućnost da se oni iskoriste nakon završetka Promocije. Prethodno
            prikupljene valute ili bodovi u okviru Aplikacije neće biti aktivni
            i neće biti moguće iskorisititi ih tokom ove Promocije. Činom
            unošenja prvog fiskalnog računa učesnici potvrđuju da su upoznati sa
            ovim pravilima, da su sa njima saglasni i da će ih poštovati, a
            takođe daju svoju saglasnost za sakupljanje i obradu svojih ličnih
            podataka isključivo za namenu i na način naveden u ovim pravilima.
            Jedan fisklani račun se može uneti samo jednom i on će omogućiti
            dobijanje odgovarajućeg broja bodova u Aplikaciji samo jedan put.
            Organizator zadržava pravo da diskvalifikuje učesnike koji ne
            poštuju Pravila ili koji su prevarom ili na bilo koji drugi
            nedozvoljen način ili način koji se protivi duhu svrhe Promocije,
            došli u posed fiskalnih racuna Organizator zadržava pravo ali ne
            preuzima obavezu da na način koji slobodno izabere proverava
            validnost bodova te da ne prihvati bodove koji nisu validni. Bodovi
            koji nisu validni su bodovi koji su iskorišćeni, generisani ili
            izmišljeni a nisu očitani sa racuna ili ukoliko je pošiljalac do
            njih došao na nedozvoljen način ili na način koji se protivi svrsi
            Programa, a to je promocija proizvoda Organizatora. U tu svrhu
            Organizator može zahtevati da mu pojedini učesnici dostave slike
            racuna sa vidljivim bodovima. Navedene mehanizme i sredstva provere
            Organizator ima takođe pravo da preduzme i u slučaju žalbe/prigovora
            učesnika da su validni bodovi koje je pokušao da unese već
            iskorišćeni. U slučaju ponovljene žalbe/prigovora učesnik će
            dostaviti Organizatoru slike racuna sa vidljivim bodovima i lokala
            koji ucestvuje. Imajući u vidu ono što je navedeno u prethodna 2
            stava ovih Pravila, potrebno je da učesnici, radi eventualne
            naknadne provere od strane Organizatora ili ispitivanja opravdanosti
            žalbi/prigovora učesnika, slikaju racune sa bodovima. U slučaju da
            učesnici prilikom provere ne poseduju sliku racuna i boda, gube
            pravo na nagradu.
          </li>
          <li>
            Učesnici Programa ne mogu da zahtevaju nagrade u većim količinama
            ili drugačije vrste nagrada od onih koje su definisane u ovim
            Pravilima od strane Organizatora.
          </li>
        </ol>
        <Typography variant="body1" component="div">
          Nakon što učesnik izabere da ce učestvovati u ovom programu, učesnik
          skuplja bodove na svom profilu. Nakon što sakupi određen broj bodova
          to će mu omogućiti da za njih kupi ponuđene nagrade.
        </Typography>
        <Typography variant="body1" component="div">
          Sakupljene bodova učesnici menjaju za neki od dostupnih nagrada na
          aplikaciji, pri čemu će im biti oduzet broj bodova u vrednosti
          izabrane nagrade.
        </Typography>
        <Typography variant="body1" component="div">
          Učesnik Programa u svako doba može proveriti stanje trenutno dostupnih
          nagrada na zalihama u Aplikaciji. Organizator ne snosi odgovornost
          ukoliko se zalihe nagrada potroše od momenta provere stanja pa do
          momenta poručivanja dostupnih nagrada kao i u slučaju da se zalihe
          nagrada definisane u ovim Pravilima potroše te određene nagrade više
          ne budu dostupne za poručivanje.
        </Typography>
        <Typography variant="body1" component="div">
          Broj nagrada je ograničen kako je navedeno u sledećoj tabeli u kojoj
          je takođe navedeno koliko je potrebno sakupiti bodova za određene
          nagrade.
        </Typography>
        <Typography
          fontWeight={700}
          variant="subtitle-1"
          component="div"
          marginBottom="8px"
          marginTop="24px"
        >
          Nagrade:
        </Typography>
        <table>
          <tr
            style={{
              textAlign: "left",
              backgroundColor: "red",
              color: "#FFFFFF",
              fontSize: "12px",
            }}
          >
            <th>Naziv nagrada</th>
            <th>Količina (kom)</th>
            <th>Broj bodova</th>
          </tr>
          <tr>
            <td style={{ fontSize: "14px" }}>Ćebe Srbija</td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>50</td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>15</td>
          </tr>
          <tr>
            <td style={{ fontSize: "14px" }}>Plažni peškir</td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>200</td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>9</td>
          </tr>
          <tr>
            <td style={{ fontSize: "14px" }}>Coca-Cola Privezak trofej</td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>1000</td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>5</td>
          </tr>
          <tr>
            <td style={{ fontSize: "14px" }}>Coca-Cola Majica L</td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>200</td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>10</td>
          </tr>
          <tr>
            <td style={{ fontSize: "14px" }}>Coca-Cola Majica XL</td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>200</td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>10</td>
          </tr>
          <tr>
            <td style={{ fontSize: "14px" }}>Ultra majica</td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>50</td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>10</td>
          </tr>
          <tr>
            <td style={{ fontSize: "14px" }}>Wilson košarkaška lopta 3x3</td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>25</td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>16</td>
          </tr>
          <tr>
            <td style={{ fontSize: "14px" }}>Kišobran Srbija</td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>30</td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>12</td>
          </tr>
          <tr>
            <td style={{ fontSize: "14px" }}>
              Poklon kartica Raiffeisen 2000din
            </td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>200</td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>14</td>
          </tr>
        </table>
        <Typography
          variant="body1"
          component="div"
          marginTop="24px"
          marginBottom="24px"
        >
          Broj nagrada, u zavisnosti od vrste nagrada, koje učesnik može
          preuzimati sa jednog registrovanog profila je ograničen i naveden je u
          sledećoj tabeli.
        </Typography>
        <table>
          <tr
            style={{
              textAlign: "left",
              backgroundColor: "red",
              color: "#FFFFFF",
              fontSize: "12px",
            }}
          >
            <th>Naziv nagrada</th>
            <th>
              Broj nagrada koji može biti preuzet sa jednog registrovanog
              profila
            </th>
          </tr>
          <tr>
            <td style={{ fontSize: "14px" }}>Ćebe Srbija</td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>2</td>
          </tr>
          <tr>
            <td style={{ fontSize: "14px" }}>Plažni peškir</td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>2</td>
          </tr>
          <tr>
            <td style={{ fontSize: "14px" }}>Coca-Cola Privezak</td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>10</td>
          </tr>
          <tr>
            <td style={{ fontSize: "14px" }}>Coca-Cola Majica L</td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>2</td>
          </tr>
          <tr>
            <td style={{ fontSize: "14px" }}>Coca-Cola Majica XL</td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>2</td>
          </tr>
          <tr>
            <td style={{ fontSize: "14px" }}>Ultra majica</td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>2</td>
          </tr>
          <tr>
            <td style={{ fontSize: "14px" }}>Wilson košarkaška lopta 3x3</td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>2</td>
          </tr>
          <tr>
            <td style={{ fontSize: "14px" }}>Kišobran Srbija</td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>2</td>
          </tr>
          <tr>
            <td style={{ fontSize: "14px" }}>
              Poklon kartica Raiffeisen 2000din
            </td>
            <td style={{ fontSize: "14px", textAlign: "center" }}>2</td>
          </tr>
        </table>
        <Typography
          fontWeight={700}
          variant="subtitle-1"
          component="div"
          marginBottom="8px"
          marginTop="24px"
        >
          Podaci za preuzimanje nagrada u okviru promocije
        </Typography>
        <Typography variant="body1" component="div">
          Nakon sto učesnik “kupi” nagradu ” biće mu dostupan link na njegovom
          profilu u okviru Aplikacije gde je potrebno upisati neophodne podatke
          za isporuku nagrada – ime i prezime, i-mejl, broj mobilnog telefona,
          broj lične karte ili pasoša, ulica, broj i mesto.
        </Typography>
        <Typography variant="body1" component="div">
          Za svaku pojedinačno osvojenu nagradu potrebno je ispratiti link za
          popunjavanje neophodnih podataka za preuzimanje ili isporuku nagrada.
          Podatke je potrebno popuniti za sve nagrade najkasnije do 07.05.2023.
          godine do kraja dana. U slučaju propuštanja ovog roka, dobitnici gube
          pravo na nagradu. Pravo na preuzimanje nagrada imaće lice čiji su
          podaci dostavljeni ovim putem i nijedno drugo lice
        </Typography>
        <Typography variant="body1" component="div">
          Nakon unosa svih podataka, na i-mejl koji je unesen prilikom
          registracije će učesniku biti poslati svi podaci koji su uneti. Izgled
          mejla koji dobija svaki učesnik po unosu podataka za preuzimanje ili
          isporuku nagrada nalazi se u nastavku:
        </Typography>
        <Stack marginTop="24px">
          <Divider />
        </Stack>
        <Typography
          marginTop="8px"
          variant="caption"
          component="div"
          fontStyle="italic"
        >
          Čestitamo!
        </Typography>
        <Typography variant="caption" component="div" fontStyle="italic">
          Uneli ste podatke i uspešno ste poručili svoju nagradu.
        </Typography>
        <Typography variant="caption" component="div" fontStyle="italic">
          Ispod možete videti detalje vaše porudžbine.
        </Typography>
        <Typography
          variant="caption"
          component="div"
          fontStyle="italic"
          marginTop="16px"
        >
          Ime:
        </Typography>
        <Typography variant="caption" component="div" fontStyle="italic">
          Prezime:
        </Typography>
        <Typography variant="caption" component="div" fontStyle="italic">
          Br. Lične karte ili pasoša:
        </Typography>
        <Typography variant="caption" component="div" fontStyle="italic">
          Br. Telefona:
        </Typography>
        <Typography variant="caption" component="div" fontStyle="italic">
          E-Mail adresa:
        </Typography>
        <Typography variant="caption" component="div" fontStyle="italic">
          Grad za isporuku nagrade:
        </Typography>
        <Typography variant="caption" component="div" fontStyle="italic">
          Ulica i broj za isporuku nagrade:
        </Typography>
        <Typography
          variant="body1"
          component="div"
          marginTop="16px"
          color="error"
        >
          Isporuka nagrada - važna napomena
        </Typography>
        <Typography
          fontWeight={700}
          variant="subtitle-1"
          component="div"
          marginBottom="8px"
          marginTop="16px"
        >
          Prilikom isporuke nagrada, morate dostavljaču pokazati ličnu kartu ili
          pasoš.
        </Typography>
        <Typography variant="body1" component="div">
          Nagrade će im biti isporučene u periodu od 08.05.2023 do 31.05.2023
          godine.
        </Typography>
        <Typography
          fontWeight={700}
          variant="subtitle-1"
          component="div"
          marginBottom="8px"
          marginTop="16px"
        >
          Pravo učestvovanja
        </Typography>
        <Typography variant="body1" component="div">
          Pravo učešća u Programu imaju isključivo lica sa prebivalištem u
          Republici Srbiji (bez Kosova i Metohije).
        </Typography>
        <Typography variant="body1" component="div">
          Pravo učešća u Programu nemaju sledeća lica:
        </Typography>
        <ul>
          <li>
            Lica koja su u radnom odnosu ili su na drugi način angažovana kod
            Organizatora kao i njihovi bračni drugovi, roditelji i deca;
          </li>
          <li>
            Lica koja su u radnom odnosu ili su na drugi način angažovana kod
            pravnih lica koja na bilo koji način učestvuju u priređivanju i
            organizaciji Programa i/ili imaju pristup podacima vezanim za
            priređivanje Programa, kao i njihovi bračni drugovi, roditelji i
            deca.
          </li>
        </ul>
        <Typography variant="body1" component="div">
          Organizator zadržava pravo da, po sopstvenom nahođenu, izvrši mere
          provere gore navedenih činjenica.
        </Typography>
        <Typography
          fontWeight={700}
          variant="subtitle-1"
          component="div"
          marginBottom="8px"
          marginTop="16px"
        >
          Preuzimanje i isporuka nagrada
        </Typography>
        <Typography variant="body1" component="div">
          Nagrade će biti isporučene na adresu dobitnika od strane JP “Pošte
          Srbije”, i to na adresu koju je dostavio dobitnik u skladu sa ovim
          Pravilima, najkasnije do 31.05.2023.. Pravo na uručenje nagrade će
          imati isključivo lice čiji su podaci dostavljeni.
        </Typography>
        <Typography variant="body1" component="div">
          Dobitnik nagrade će biti obavešten neposredno pre isporuke nagrade o
          samoj isporuci. Ukoliko se dobitnik ne bude nalazio na adresi koju je
          dostavio, biće ostavljen izveštaj o prispeću pošiljke, a takođe će
          dobitnik dobiti SMS poruku sa informacijom i adresom gde može preuzeti
          nagradu u narednih pet dana od dana kada je izveštaj o prispeću
          ostavljen na adresi koja je dostavljena-prijavljena. Nakon isteka tih
          pet dana dobitnik gubi pravo na nagradu.
        </Typography>
        <Typography variant="body1" component="div">
          Podaci za preuzimanje nagrada moraju da se odnose isključivo na lice
          koje poseduje važeću ličnu kartu ili pasoš.
        </Typography>
        <Typography variant="body1" component="div">
          Količine nagrada i period trajanja su ograničeni u skladu sa ovim
          Pravilima.
        </Typography>
        <Typography variant="body1" component="div">
          Lične podatke o učesnicima u Programu Organizator će koristiti
          isključivo za potrebe izvršenja obaveza prema dobitnicima nagrada.
          Podaci potrebni za dostavu nagrada biće dostavljeni poštanskom
          operatoru sa sedištem na teritoriji Republike Srbije sa kojim je
          Organizator zaključio ugovor o isporuci nagrada, u skladu sa Zakonom o
          poštanskim uslugama. Lični podaci učesnika će biti čuvani i obrađivani
          u skladu sa propisima o zaštiti podataka o ličnosti, uz preduzimanje
          razumnih mera fizičke i elektronske zaštite, a biće izbrisani nakon
          okončanja Programa, kao i izvršavanja svih obaveza Organizatora prema
          učesnicima, u zavisnosti od toga koji momenat kasnije nastupi. Prema
          važećim propisima o zaštiti podataka o ličnosti, u slučaju
          nedozvoljene obrade podataka lice na koje se podaci odnose ima pravo
          da traži brisanje podataka, kao i prekid ili privremenu obustavu
          vršenja obrade u slučaju osporavanja ispravnosti, potpunosti i
          tačnosti podataka, uz pravo da takvi podaci budu označeni kao osporeni
          do odluke o njihovoj ispravnosti, potpunosti i tačnosti.
        </Typography>
        <Typography variant="body1" component="div">
          Organizator ne pokriva učesnicima troškove učestovanja niti
          preuzimanja nagrada ukoliko se dobitnik ne bude nalazio na adresi koju
          je dostavio.
        </Typography>
        <Typography
          fontWeight={700}
          variant="subtitle-1"
          component="div"
          marginBottom="8px"
          marginTop="16px"
        >
          Kršenje pravila i zloupotrebe
        </Typography>
        <Typography variant="body1" component="div">
          Ukoliko Organizator proceni da je došlo do kršenja pravila Programa i
          do njegove zloupotrebe na bilo koji način, ovlašćen je da uskrati
          isporuku nagrada učesniku koji je izvršio kršenje ili zloupotrebu i da
          ga privremeno ili trajno isključi iz daljeg učestvovanja u Programu.
        </Typography>
        <Typography
          fontWeight={700}
          variant="subtitle-1"
          component="div"
          marginBottom="8px"
          marginTop="16px"
        >
          Žalbe i reklamacije
        </Typography>
        <Typography variant="body1" component="div">
          U cilju što ažurnijeg rešavanja eventualnih primedbi da su dostavljeni
          nagrade oštećene, Organizator definiše ubrzanu proceduru rešavanja
          reklamacija, a kako sledi:
        </Typography>
        <Typography variant="body1" component="div">
          U roku od 3 dana od dana preuzimanja nagrada, dobitnik se može javiti
          Organizatoru preko besplatne info linije 0800 11 22 33 radi
          Reklamacije, pri čemu je potrebno da izabere taster 1, a takođe može
          poslati slike oštećene nagrade na cris.operator.1@cchellenic.com i
          cris.operator.3@cchellenic.com
        </Typography>
        <Typography variant="body1" component="div">
          Ukoliko je reklamacija opravdana, i ukoliko želi da mu oštećena
          nagrada bude zamenjena, dobitnik je dužan da pošalje oštećenu nagradu
          na adresu Organizatora sa svojim podacima, nakon čega će mu
          Organizator dostaviti novu nagradu.
        </Typography>
        <Typography variant="body1" component="div">
          Reklamacije upućene Organizatoru nakon završetka promocije i 3 dana
          nakon definisanog krajnjeg datuma za preuzimanje nagrada neće biti
          razmatrane.
        </Typography>
        <Typography variant="body1" component="div">
          Ova procedura ne utiče na prava dobitnika definisana propisima o
          zaštiti potrošača.
        </Typography>
        <Typography
          fontWeight={700}
          variant="subtitle-1"
          component="div"
          marginBottom="8px"
          marginTop="16px"
        >
          Mogućnost prekida Programa
        </Typography>
        <Typography variant="body1" component="div">
          Program može biti prekinut u slučaju nastupanja okolnosti za koje
          Organizator nije odgovoran, odnosno, koje nije mogao da spreči ili
          otkloni.
        </Typography>
        <Typography variant="body1" component="div">
          U slučaju prekida programa, učesnici će biti obavešteni putem
          sredstava javnog informisanja ili putem veb stranice coke loyalty
        </Typography>
        <Typography
          fontWeight={700}
          variant="subtitle-1"
          component="div"
          marginBottom="8px"
          marginTop="16px"
        >
          Odgovornost
        </Typography>
        <Typography variant="body1" component="div">
          Organizator ne preuzima odgovornost za bilo kakvu štetu koja nastane
          zloupotrebom ovog Programa, a koja se na taj način od strane učesnika
          ili trećih lica nanese bilo drugim učesnicima Programa, bilo trećim
          licima.
        </Typography>
        <Typography variant="body1" component="div">
          Organizator takodje zadržava pravo izmene tehničke specifikacije
          nagrada tj. prezentovane slike nagrada ili navedenog modela i njihovi
          opisi nisu obavezujući.
        </Typography>
        <Typography
          fontWeight={700}
          variant="subtitle-1"
          component="div"
          marginBottom="8px"
          marginTop="16px"
        >
          Mogućnost izmene pravila Programa
        </Typography>
        <Typography variant="body1" component="div">
          Organizator zadržava pravo da napravi određene izmene u pravilima
          Programa iz tehničkih, poslovnih ili razloga vezanih za javnost, bez
          diranja u stečena prava učesnika, kao i da u slučaju više sile
          obustavi odvijanje Programa.
        </Typography>
        <Typography variant="body1" component="div">
          U slučaju bilo kakavih promena, Organizator će obavestiti učesnike
          putem web stranice Coke Loyalty.
        </Typography>
        <Typography variant="body1" component="div" textAlign="right">
          O R G A N I Z A T O R
        </Typography>
        <Typography variant="body1" component="div" textAlign="right">
          COCA-COLA HBC-SRBIJA D.O.O.
        </Typography>
      </DialogContent>
    </Dialog>
  );
};
export default RulesModal;
